import './assets/styles/app.scss';

import Home from "./pages/Home"
import Contact from "./pages/Contact";
import RootLayout from "./layout/RootLayout";
import Products from "./pages/Products";
import CheckOutForm from "./forms/CheckOutForm";
import Unauthorised from "./components/Unauthorised";
import Account from "./pages/Account";
import RequireAuth from "./components/RequireAuth";
import Privacy from "./pages/Privacy";
import AddressBook from "./pages/AddressBook";
import About from "./pages/About";
import Bulletin from "./pages/Bulletin";
import PaginatedOrders from "./pages/PaginatedOrders";
import Orders from "./pages/Orders";
import Order from "./pages/Order";
import ReOrder from "./pages/ReOrder";
import Login from "./pages/Login";
import PageNotFound from "./pages/PageNotFound";
import { Routes } from "react-router";
import { Route } from "react-router-dom";
import GuestLayout from "./layout/GuestLayout";
import RequireCredit from "./components/RequireCredit";


require('bootstrap/dist/js/bootstrap.bundle');

function App() {
  return (
    <Routes>
      <Route element={<GuestLayout />}>
        <Route exact path="login" element={<Login />} />
        <Route path="unauthorized" element={<Unauthorised />} />
      </Route>

      <Route path="/" element={<RootLayout />}>
        <Route element={<RequireAuth allowedRoles={['ROLE_USER']} />}>
          <Route exact path="/" element={<Home />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="about" element={<About />} />
          <Route path="bulletin" element={<Bulletin />} />
          <Route path="products" element={<Products />} />
          <Route path="account" element={<Account />} />
          <Route path="checkout" element={<CheckOutForm />} />
          <Route path="address-book" element={<AddressBook />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/paginated" element={<PaginatedOrders />} />
          <Route path="order/:seqno" element={<Order />} />
          <Route path="order/:seqno/reorder" element={<ReOrder />} />
          <Route element={<RequireCredit />}>
            <Route path="checkout" element={<CheckOutForm />} />
          </Route>
        </Route>
      </Route>
      {/* catch all */}
      <Route exact path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
